/**
 * Gli stati di disabled e readOnly possono essere attivi contemporaneamente.
 * Se settati entrambi, vince il readOnly. Se entrambi sono false, il componente è attivo.
 * @param {bool} disabled
 * @param {bool} readOnly
 */
function useActivation(disabled, readOnly) {
  return ({
    active: !disabled && !readOnly,
    disabled: !readOnly && disabled,
    readOnly,
  });
}

export default useActivation;
